import React from 'react';
import { ChevronRight, Zap, Activity, MapPin, WifiOff } from 'lucide-react';
import './PlantCard.css';

// Consumes the merged plant object /api/plants already returns
// (plant_id, name, location, panel_count, total_power, active, has_telemetry)
// - never computes or invents its own numbers.
export default function PlantCard({ plant, onClick }) {
  const offline = !plant.has_telemetry;
  return (
    <div className={`plant-card${offline ? ' plant-card-offline' : ''}`} onClick={onClick} role="button" tabIndex={0}>
      <div className="plant-card-header">
        <h4>🌿 {plant.name || plant.plant_id}</h4>
        <ChevronRight size={18} className="chevron-icon" />
      </div>
      {plant.location && (
        <div className="plant-card-location"><MapPin size={13} /> {plant.location}</div>
      )}
      <div className="plant-card-stats">
        <div className="plant-stat">
          <Zap size={16} />
          <span className="stat-value">{plant.total_power.toFixed(1)} W</span>
        </div>
        <div className="plant-stat">
          <Activity size={16} />
          <span className="stat-value">{plant.panel_count} panneau(x)</span>
        </div>
      </div>
      {offline && (
        <div className="plant-card-offline-tag"><WifiOff size={13} /> Aucune donnée</div>
      )}
      {plant.active === false && <div className="plant-card-inactive-tag">Inactif</div>}
    </div>
  );
}
